"use strict";

import $ from 'jquery'
import forEach from 'lodash/forEach'

function onRelatedChange(){
    var $this = $(this);
    var val = ($this.val() || "").toLowerCase();
    if ($this.is(":checkbox,:radio") && !$this.is(":checked")) {
        val = "";
    }
    var relateds = $this.data("ls-show-related").targets;
    forEach(relateds, related => {
        var rv = false;
        for (var k = 0; k < related.values.length; k++) {
            if (val == related.values[k]) {
                rv = true;
                break;
            }
        }
        if (related.settings.negate) {
            rv = !rv;
        }
        related.item[rv ? "show" : "hide"]();
    });
    for (var j = 0; j < relateds.length; j++) {
        var related = relateds[j];
        var rv = false;
        for (var k = 0; k < related.values.length; k++) {
            if (val == related.values[k]) {
                rv = true;
                break;
            }
        }
        if (related.settings.negate) {
            rv = !rv;
        }
        related.item[rv ? "show" : "hide"]();
    }
}

export default function(){
    $("[data-show-related]", this).each(function (i, item) {
        var $item = $(item);
        var related = $($item.attr("data-show-related"));
        if (related.data("ls-show-related") == undefined) {
            related.data("ls-show-related", {
                targets: []
            });
            related.change(onRelatedChange);
        }
        var data = related.data("ls-show-related");
        var showValues = $item.data("show-related-value");
        if (!$.isArray(showValues)) {
            showValues = [($item.attr("data-show-related-value") || "").toLowerCase()];
        }
        var settings = $item.data("show-settings") || {};
        settings = $.extend({}, { negate: false }, settings);
        data.targets.push({ item: $item, values: showValues, settings: settings });
        var val = (related.val() || "").toLowerCase();
        if (related.is(":checkbox,:radio") && !related.is(":checked")) {
            val = "";
        }
        var rv = false;
        for (var k = 0; k < showValues.length; k++) {
            if (val == showValues[k]) {
                rv = true;
                break;
            }
        }
        if (settings.negate) {
            rv = !rv;
        }
        $item[rv ? "show" : "hide"]();
    });
}




// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/showRelated.js